const CLIENT_TABS = {
  order_confirmed: 'orders', delivery_completed: 'orders', delivery_failed: 'orders',
  route_started: 'orders', delivery_rated: 'orders',
  dispute_opened: 'disputes', dispute_update: 'disputes', dispute_forwarded: 'disputes',
  seller_incident: 'disputes', traiteur_incident: 'disputes',
  container_return: 'vouchers', container_reconciliation: 'vouchers',
  delivery_time_slot: 'orders', reservation_deposit_paid: 'orders', reservation_balance_paid: 'orders',
};

const ADMIN_TABS = {
  partner_dossier_stalled: 'seller-validation', partner_document_uploaded: 'seller-validation', reservation_deposit_paid: 'reservations', reservation_balance_paid: 'reservations',
  message: 'messaging', new_message: 'messaging', announcement: 'notifications', delivery_time_slot: 'timeslots',
  option_request: 'options', dispute_opened: 'disputes', dispute_update: 'disputes', dispute_forwarded: 'disputes',
  seller_incident_admin: 'disputes', traiteur_incident_admin: 'disputes',
  container_reconciliation: 'containers', container_return: 'containers',
  order_confirmed: 'order-tracking', delivery_completed: 'delivery', delivery_failed: 'delivery',
  route_started: 'delivery', route_assigned: 'delivery',
};

const PARTNER_TABS = {
  option_decision: 'subscription', option_month_end_reminder: 'subscription', dispute_update: 'orders', dispute_opened: 'orders',
  order_confirmed: 'orders', container_reconciliation: 'orders', message: 'contact', new_message: 'contact', announcement: 'contact',
  partner_document_reviewed: 'profile', missing_documents_reminder: 'profile', dropoff_eve_reminder: 'prep', dispute_forwarded: 'orders',
  seller_incident: 'orders', traiteur_incident: 'orders', delivery_time_slot: 'orders', delivery_completed: 'orders', delivery_failed: 'orders',
};

/** Resolve the page a notification should open, based on its type and the viewer's role. */
export function notificationLink(n, role) {
  if (n?.link && typeof n.link === 'string' && n.link.startsWith('/')) return n.link;
  const t = n?.type || '';
  if (role === 'admin') return `/admin?tab=${ADMIN_TABS[t] || 'notifications'}`;
  if (role === 'seller') return `/vendeur?tab=${PARTNER_TABS[t] || 'orders'}`;
  if (role === 'traiteur') return `/traiteur?tab=${PARTNER_TABS[t] || 'orders'}`;
  if (role === 'driver' || role === 'livreur') return '/livreur';
  return `/profil?tab=${CLIENT_TABS[t] || 'orders'}`;
}
